<div class="modal-header">
    <h4 class="modal-title">
        {{
            pageMode === PageMode.create
                ? ("national_strategies.enabler_objectives.new_eo" | translate)
                : ("national_strategies.enabler_objectives.edit_eo" | translate)
        }}
    </h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body">
    <form class="col-12" [formGroup]="subDirectionForm">
        @if (pageMode !== PageMode.create) {
            <div class="row">
                <div class="col-12">
                    <adaa-form-input
                        controlName="refCode"
                        formControlName="refCode"
                        [invalid]="submitted && subDirectionForm.get('refCode')?.invalid!"
                        [label]="'common.form.label.refcode' | translate"
                        [setValidator]="validations"
                    />
                </div>
            </div>
        }
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    controlName="nameAE"
                    formControlName="nameAE"
                    [invalid]="submitted && subDirectionForm.get('nameAE')?.invalid!"
                    [label]="'common.form.label.nameAE' | translate"
                    [setValidator]="validations"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    controlName="nameEN"
                    formControlName="nameEN"
                    [invalid]="submitted && subDirectionForm.get('nameEN')?.invalid!"
                    [label]="'common.form.label.nameEN' | translate"
                    [setValidator]="validations"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    controlName="dscAE"
                    formControlName="dscAE"
                    [invalid]="submitted && subDirectionForm.get('dscAE')?.invalid!"
                    [label]="'common.form.label.descriptionAE' | translate"
                    [setValidator]="validations"
                    [isTextArea]="true"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    controlName="dscEN"
                    formControlName="dscEN"
                    [invalid]="submitted && subDirectionForm.get('dscEN')?.invalid!"
                    [label]="'common.form.label.descriptionEN' | translate"
                    [setValidator]="validations"
                    [isTextArea]="true"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-dropdown
                    controlName="owner"
                    formControlName="owner"
                    appendTo=".modal-content"
                    [label]="'directions.team_owner' | translate"
                    [setValidator]="validations"
                    [invalid]="submitted && subDirectionForm.get('owner')?.invalid!"
                    [options]="ownerGroups"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-dropdown
                    [label]="'directions.type' | translate"
                    formControlName="type"
                    controlName="type"
                    [options]="subGovDirTypes()"
                    [setValidator]="validations"
                    [invalid]="submitted && subDirectionForm.get('type')?.invalid!"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12 d-flex align-items-center my-3 ms-2">
                <adaa-form-checkbox [label]="'directions.is_main' | translate" controlName="isMain" formControlName="isMain" />
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.cancel" | translate }}</button>
    @if (pageMode !== PageMode.view) {
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    }
</div>
